import { put, call, takeEvery } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";

import { logoutRequest } from "../../login/actions";

import {
  DELETE_PLAYLIST_REQUEST,
  deletePlaylistSuccess,
  deletePlaylistError,
} from "./actions";
import { Env } from "../../../env";

function* deletePlaylistRequest(action) {
  const { userId, accessToken, id } = action;

  try {
    yield call(
      axios.delete,
      `${Env.BASE_API_URL}/Accounts/${userId}/Playlists/${id}`,
      {
        headers: { Authorization: accessToken },
      }
    );
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(deletePlaylistError(id));
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }

    return;
  }

  yield put(deletePlaylistSuccess(id));

  yield put(flashMessage("La playlist a été supprimée avec succès."));
}

export default function* watchDeletePlaylistRequest() {
  yield takeEvery(DELETE_PLAYLIST_REQUEST, deletePlaylistRequest);
}



// WEBPACK FOOTER //
// ./src/pages/playlists/delete/saga.js